exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".instanceItem.insta_immma{min-height:1px}.imagg_kk{overflow:hidden}.info-box.iii{min-height:120px}.name_innss_xx{height:70px;overflow:hidden;font-size:17px}.nomap{color:red}.mapps_oo{margin-top:4px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/views/instances/instances.css
// module id = 235
// module chunks = 0